'use client';

import { createContext, useContext, useState } from 'react';
const CustomOrgContext = createContext<any>(undefined);
export function CustomOrgWrapper({
  children
}: {
  children: React.ReactNode;
}) {
  const [CustomOrg, setCustomOrg] = useState({});
  return <CustomOrgContext.Provider value={{
    setCustomOrg,
    CustomOrg
  }} data-sentry-element="unknown" data-sentry-component="CustomOrgWrapper" data-sentry-source-file="customOrgContext.tsx">
   {children}
  </CustomOrgContext.Provider>;
}
export function useCustomOrgContext() {
  return useContext(CustomOrgContext);
}